import React from "react";

export default function HowKryptogramWork() {
  return (
    <>
      <div className="tp-service-4-area pt-20 fix">
        <div className="container">
          <div className="row">
            <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
              <div className="tp-price-item">
                <div
                  className="tp-price-head "
                  style={{
                    backgroundImage: "url(assets/img/one/step01.png)",
                  }}
                >
                  <span>Step 1</span>
                  <h5>Buy Kryptogram NFTs</h5>
                </div>
                <div className="tp-price-body">
                  <div className="tp-price-list pb-110">
                    <ul>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        Purchase your Kryptogram NFTs. Exclusively through the
                        Kryptogram NFT marketplace.
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
              <div className="tp-price-item">
                <div
                  className="tp-price-head "
                  style={{
                    backgroundImage: "url(assets/img/one/step02.png)",
                  }}
                >
                  <span>Step 2</span>
                  <h5>Unlock Your Benefits</h5>
                </div>
                <div className="tp-price-body">
                  <div className="tp-price-list pb-5">
                    <ul>
                      <h5 className="tp-price-monthly ">1 NFT</h5>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        Entry to Tribe O Crypto Festival
                      </li>
                      <h5 className="tp-price-monthly ">5 NFTs</h5>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        Ownership of 100 sq. ft. of land on Kryptogram Island +
                        a visitor visa
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-lg-4 col-md-6 mb-30">
              <div className="tp-price-item">
                <div
                  className="tp-price-head "
                  style={{
                    backgroundImage: "url(assets/img/one/step03.png)",
                  }}
                >
                  <span>Step 3</span>
                  <h5> Future Utility Expansion</h5>
                </div>
                <div className="tp-price-body">
                  <span className="tp-price-monthly"></span>
                  <div className="tp-price-list">
                    <ul>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        NFT Staking & Yield Farmingt
                      </li>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        Exclusive Holder Perks
                      </li>
                      <li>
                        <i className="fa-sharp fa-light fa-check" />
                        Integration with Future Web3 Projects
                      </li>
                    </ul>
                  </div>
                </div>
                <br />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
